import { Injectable } from '@angular/core';

import Cookies from 'js-cookie';

import { COOKIES_LENGTH } from '../constants';

@Injectable({ providedIn: 'root' })
export class DpSiteContextCookiesService {
  setCookie(name: string, value: string): void {
    Cookies.remove(name);
    const date = new Date();
    date.setTime(date.getTime() + COOKIES_LENGTH);
    Cookies.set(`${name}`, value, { expires: date });
  }
}
